// @ts-strict-ignore
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProjectModel } from '@project/model/project.model';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { UserUtils } from '@user/service/user-utils';
import { UserActionsLoggingManager } from '@user/service/logging/user-actions-logging.manager';
import { ProjectVO } from '@project/model/vo/project.vo';
import { ProjectNavigationPresenter } from '@project-navigation/project-navigation.presenter';
import { ProjectComponentPresenter } from '../../components/project-component.presenter';
import { CaeImportService } from '../cae-import.service';

export enum ActionType {
  export,
  import,
}

@Component({
  standalone: false,
  templateUrl: './choice-action-cae.component.html',
  selector: 'app-choice-action-cae',
})
export class ChoiceActionCaeComponent {
  public readonly types: ActionType[] = [ActionType.import, ActionType.export];

  public actionType: ActionType = ActionType.import;

  constructor(
    private bsModalRef: BsModalRef,
    private userActionsLoggingManager: UserActionsLoggingManager,
    private projectNavigationPresenter: ProjectNavigationPresenter,
    private projectModel: ProjectModel,
    private localeResourceManager: LocaleResourceManager,
    private projectComponentPresenter: ProjectComponentPresenter,
    private caeImportService: CaeImportService,
  ) {}

  public get currentProject(): ProjectVO {
    return this.projectModel.currentProject;
  }

  public async onConfirm(): Promise<void> {
    switch (this.actionType) {
      case ActionType.export:
        this.caeExport();
        this.close();
        break;
      case ActionType.import:
        await this.caeImport();
        this.close();
        break;
    }
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public async caeImport(): Promise<void> {
    await this.caeImportService.startCaeImport();
  }

  public async caeExport(): Promise<void> {
    if (UserUtils.hasEditProjectPermission(this.projectModel.user) && this.projectModel.currentProjectRequiresSaving) {
      const saved = await this.projectComponentPresenter.openSaveProjectPopUp();
      if (saved) {
        this.openCaeExport();
      }
    } else {
      this.openCaeExport();
    }
  }

  private openCaeExport() {
    this.userActionsLoggingManager.logFunction('Cae_Export');
    this.projectNavigationPresenter.openExportCaeDialog();
  }

  public openHELPLink(): void {
    window.open(this.localeResourceManager.getValueByKey(`helplink.caeexport`), `_blank`);
  }
}
